import { render, staticRenderFns } from "./navigation-drawer.vue?vue&type=template&id=4feb2b04&scoped=true"
import script from "./navigation-drawer.vue?vue&type=script&lang=js"
export * from "./navigation-drawer.vue?vue&type=script&lang=js"
import style0 from "./navigation-drawer.vue?vue&type=style&index=0&id=4feb2b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb2b04",
  null
  
)

export default component.exports